var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogicGroupActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04087 0H19.9591C22.1855 0 24 1.81937 24 4.05067V19.9493C24 22.1855 22.1855 24 19.9591 24H4.04087C1.81447 24 0 22.1806 0 19.9493V17.8897C0 17.4042 0.397223 17.0069 0.882715 17.0069C1.36821 17.0069 1.76543 17.4042 1.76543 17.8897V19.9493C1.76543 21.2096 2.78545 22.2346 4.04087 22.2346H19.9591C21.2145 22.2346 22.2346 21.2096 22.2346 19.9493V4.05067C22.2346 2.79036 21.2145 1.76543 19.9591 1.76543H4.04087C2.78545 1.76543 1.76543 2.79036 1.76543 4.05067L1.76543 6.11729C1.76543 6.6048 1.37022 7 0.882713 7C0.395204 7 0 6.6048 0 6.11729V4.05067C0 1.81447 1.81447 0 4.04087 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 9.44771 0.447715 9 1 9H11C11.5523 9 12 9.44771 12 10C12 10.5523 11.5523 11 11 11H1C0.447715 11 0 10.5523 0 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44771 15 8 15H18C18.5523 15 19 14.5523 19 14C19 13.4477 18.5523 13 18 13H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicGroupActive);
export default __webpack_public_path__ + "static/media/logic-group-active.e825cdca9463bb8618489bfdc6ae99ec.svg";
export { ForwardRef as ReactComponent };